import React from 'react';
import { Box, Container, Typography, Grid, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import SchoolIcon from '@mui/icons-material/School';
import CodeIcon from '@mui/icons-material/Code';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.primary,
                color: theme.palette.text.default,
                py: 3,
                mt: 4,
                textAlign: 'center',
                fontSize: '0.875rem',
            }}
        >
            <Container maxWidth="md">
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12} sm={4} md={3} textAlign="center">
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t('footer.resources')}
                        </Typography>
                        <Link onClick={() => navigate('/courses/html')} color="inherit" underline="hover" sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 }}>
                            <SchoolIcon fontSize="small" sx={{ mr: 0.5 }} /> {t('footer.htmlGuide')}
                        </Link>
                        <Link onClick={() => navigate('/courses/css')} color="inherit" underline="hover" sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 }}>
                            <CodeIcon fontSize="small" sx={{ mr: 0.5 }} /> {t('footer.cssBasics')}
                        </Link>
                        <Link onClick={() => navigate('/courses/javascript')} color="inherit" underline="hover" sx={{ cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 }}>
                            <DeveloperModeIcon fontSize="small" sx={{ mr: 0.5 }} /> {t('footer.javascriptTutorials')}
                        </Link>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3} textAlign="center">
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t('footer.company')}
                        </Typography>
                        <Link onClick={() => navigate('/about-us')} color="inherit" underline="hover" sx={{ cursor: 'pointer', display: 'block', mb: 1 }}>
                            {t('footer.aboutUs')}
                        </Link>
                        <Link onClick={() => navigate('/careers')} color="inherit" underline="hover" sx={{ cursor: 'pointer', display: 'block', mb: 1 }}>
                            {t('footer.careers')}
                        </Link>
                        <Link onClick={() => navigate('/contact')} color="inherit" underline="hover" sx={{ cursor: 'pointer', display: 'block', mb: 1 }}>
                            {t('footer.contact')}
                        </Link>
                    </Grid>

                    <Grid item xs={12} sm={4} md={3} textAlign="center">
                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t('footer.socialMedia')}
                        </Typography>
                        <Box display="flex" justifyContent="center">
                            <IconButton href="https://www.facebook.com/Abubakro1o/" target='_blank' color="inherit" aria-label="Facebook">
                                <FacebookIcon fontSize="small" />
                            </IconButton>
                            <IconButton href="https://github.com/Positiveoo1" target='_blank' color="inherit" aria-label="GitHub">
                                <GitHubIcon fontSize="small" />
                            </IconButton>
                            <IconButton href="https://www.linkedin.com/in/abubakrsiddik-abdurakhimov/" target='_blank' color="inherit" aria-label="LinkedIn">
                                <LinkedInIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>

                <Typography variant="body2" color="inherit" mt={3}>
                    © {new Date().getFullYear()} NexLearn. {t('footer.rightsReserved')}
                </Typography>
            </Container>
        </Box>
    );
};

export default Footer;
